let idx = 0;

const uuid = () => {
  return idx++;
};

const generateId = (name) => {
  return `id${name ? `-${name}` : ""}-${uuid()}`;
};

export default generateId;
